import { env } from '@automata/utils';

export const GlobalRoutes = {
  notFound: '/not-found',
  authorize: env('NEXT_PUBLIC_AUTH0_CALLBACK'),
  home: '/',
  homeOrg: '/:org/',
  overhead: '/:org/overhead',
  overheadID: '/:org/overhead/:id',
  operator: '/:org/manager',
  canvasWorkflow: '/:org/canvas-workflows',
  canvasWorkflowEdit: '/:org/canvas-workflows/new',
  canvasWorkflowEditID: '/:org/canvas-workflows/:id',
  workflow: '/:org/workflows',
  runhistory: '/:org/run-history',
  runhistoryID: '/:org/run-history/:id',
  users: '/:org/users',
  auditLogs: '/:org/auditLogs',
  workcells: '/:org/workcells',
  calendar: '/:org/calendar',
} as const satisfies Record<string, string>;

export type RouteKey = keyof typeof GlobalRoutes;
